import React from 'react'
import { Modal, Button, ModalInjectedProps } from '@sketch/components'
import { useGetConnectIntegrationUrl } from '../../hooks'
import { GetIntegrationConnectUrlMutationVariables } from '@sketch/gql-types'

interface ConnectIntegrationModalProps extends ModalInjectedProps {
  integrationName: string
  integrationProvider: GetIntegrationConnectUrlMutationVariables['provider']
  workspaceId: GetIntegrationConnectUrlMutationVariables['workspaceIdentifier']
}

export const ConnectIntegrationModal: React.FC<
  ConnectIntegrationModalProps
> = ({ hideModal, integrationName, integrationProvider, workspaceId }) => {
  const { getIntegrationConnectUrl, loading } = useGetConnectIntegrationUrl()

  const handleContinue = () => {
    getIntegrationConnectUrl({
      variables: {
        provider: integrationProvider,
        workspaceIdentifier: workspaceId,
      },
    })
  }

  return (
    <Modal title="You’re leaving sketch.com" onCancel={hideModal}>
      <Modal.Body>
        <p>
          We’ll redirect you to {integrationName}’s website to complete the
          integration between Sketch and {integrationName}.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={hideModal}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleContinue} loading={loading}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
